// DeviceDetails.js
import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Grid,
    TextField,
    IconButton,
    Select,
    MenuItem,
    FormControl,
    FormHelperText
} from '@mui/material';
import Upload_Icon from '../../images/vehicle/Upload_icon.svg';
import Upload_Edit_Icon from '../../images/vehicle/Upload_Edit_icon.svg';

export default function DeviceDetails({
    formData,
    handleInputChange,
    handleImageUpload,
    handleRemoveImage,
    RequiredLabel,
    StandardLabel,
    errors = {},
    t
}) {
    return (
        <Box
            sx={{
                padding: { xs: '20px', md: '40px' },
                margin: { xs: '0px 20px', md: '0px 40px' },
                backgroundColor: '#FFFFFF',
                border: '1px solid #A5DCF3',
                borderRadius: '10px',
                boxShadow: '-2px 2px 5px 0px #00000040',
                mb: 3,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Paper
                    sx={{
                        height: 52,
                        width: '100%',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        backgroundColor: '#647490',
                        boxShadow: '-2px 2px 5px 0px #00000040',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        variant="h6"
                        color="white"
                        sx={{ fontSize: { xs: '18px', md: '20px' } }}
                    >
                        {t('Device Details')}
                    </Typography>
                </Paper>
            </Box>
            <Grid container spacing={4}>
                <Grid item xs={12} md={8}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} mb={1}>
                                <RequiredLabel label={t('Device ID')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('typedeviceId')}
                                    value={formData.deviceId || ''}
                                    onChange={(e) => handleInputChange(e, 'deviceId')}
                                    error={!!errors.deviceId}
                                    helperText={errors.deviceId}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.deviceId ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.deviceId ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.deviceId ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} mb={1.5}>
                                <StandardLabel label={t('Device IMEI Number')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('Type Device IMEI Number')}
                                    value={formData.imeiNumber || ''}
                                    onChange={(e) => handleInputChange(e, 'imeiNumber')}
                                    error={!!errors.imeiNumber}
                                    helperText={errors.imeiNumber}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.imeiNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.imeiNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.imeiNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} mb={1.5}>
                                <StandardLabel label={t('Model')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('Type Model ')}
                                    value={formData.model || ''}
                                    onChange={(e) => handleInputChange(e, 'model')}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: '2px solid #183059',
                                            '&:hover': {
                                                border: '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} mb={1.5}>
                                <StandardLabel label={t('Vendor/Brand')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('Type Vendor/Brand')}
                                    value={formData.vendorBrand || ''}
                                    onChange={(e) => handleInputChange(e, 'vendorBrand')}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: '2px solid #183059',
                                            '&:hover': {
                                                border: '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} mb={1.5}>
                                <StandardLabel label={t('Working Condition')} />
                                <FormControl fullWidth error={!!errors.workingCondition}>
                                    <Select
                                        value={formData.workingCondition || ''}
                                        onChange={(e) => handleInputChange(e, 'workingCondition')}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return (
                                                    <span style={{ color: "#C8CBD0" }}>
                                                        {t('selectWorkingCondition')}
                                                    </span>
                                                );
                                            }
                                            const labels = {
                                                WORKING: t('Working'),
                                                NOT_WORKING: t('Not Working'),
                                                NEEDS_REPAIR: t('Needs Repair'),
                                            };

                                            return labels[selected] || selected;
                                        }}
                                        sx={{
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '0 24px',
                                            border: '2px solid #183059',
                                            '&:hover': { border: '2px solid #183059' },
                                            '&.Mui-focused': { border: '2px solid #183059' },
                                            '& fieldset': { border: 'none' },
                                        }}
                                    >
                                        <MenuItem value="WORKING">{t('Working')}</MenuItem>
                                        <MenuItem value="NOT_WORKING">{t('Not Working')}</MenuItem>
                                        <MenuItem value="NEEDS_REPAIR">{t('Needs Repair')}</MenuItem>
                                    </Select>
                                    {errors.workingCondition && (
                                        <FormHelperText>{errors.workingCondition}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} mb={1}>
                                <RequiredLabel label={t('Status')} />
                                <FormControl fullWidth error={!!errors.status}>
                                    <Select
                                        value={formData.status || ''}
                                        onChange={(e) => handleInputChange(e, 'status')}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return (
                                                    <span style={{ color: "#C8CBD0" }}>
                                                        {t('selectStatus')}
                                                    </span>
                                                );
                                            }

                                            // Map enum values to user-friendly labels
                                            const labels = {
                                                INSTALLED: t('Installed'),
                                                PENDING: t('Not Installed'),
                                                REMOVED: t('Removed'),
                                            };

                                            return labels[selected] || selected;
                                        }}
                                        sx={{
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '0 24px',
                                            border: errors.status ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': { border: errors.status ? '2px solid #d32f2f' : '2px solid #183059' },
                                            '&.Mui-focused': { border: errors.status ? '2px solid #d32f2f' : '2px solid #183059' },
                                            '& fieldset': { border: 'none' },
                                        }}
                                    >
                                        <MenuItem value="INSTALLED">{t('Installed')}</MenuItem>
                                        <MenuItem value="PENDING">{t('Not Installed')}</MenuItem>
                                        {/* <MenuItem value="REMOVED">{t('Removed')}</MenuItem> */}
                                    </Select>
                                    {errors.status && (
                                        <FormHelperText>{errors.status}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} mb={1.5}>
                                <StandardLabel label={t('Device Remarks')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('Type Device Remarks')}
                                    value={formData.remarks || ''}
                                    onChange={(e) => handleInputChange(e, 'remarks')}
                                    multiline
                                    rows={4}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: '2px solid #183059',
                                            '&:hover': {
                                                border: '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box
                        sx={{
                            width: '100%',
                            border: errors.deviceImage ? '2px dashed #d32f2f' : '2px dashed #183059',
                            borderRadius: 2,
                            height: 350,
                            backgroundColor: '#E8EAEE',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        {formData.deviceImagePreview ? (
                            <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                                <img
                                    src={formData.deviceImagePreview}
                                    alt="Device"
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                />
                                <IconButton
                                    onClick={handleRemoveImage}
                                    sx={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                    }}
                                    size="small"
                                >
                                    <img src={Upload_Edit_Icon} alt="Remove" style={{ filter: 'invert(1)' }} />
                                </IconButton>
                            </Box>
                        ) : (
                            <>
                                <img src={Upload_Icon} alt="Upload" style={{ width: 50, height: 50 }} />
                                <Typography
                                    variant="body1"
                                    sx={{
                                        mt: 2,
                                        color: '#1F242E',
                                        fontFamily: 'Roboto',
                                        fontWeight: 600,
                                        fontSize: '20px',
                                        lineHeight: '100%',
                                        textAlign: 'center',
                                    }}
                                >
                                    {t('Device Image')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        mt: 0.5,
                                        color: '#647490',
                                        fontFamily: 'Roboto',
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        textAlign: 'center',
                                    }}
                                >
                                    {t('Format: Jpg, Svg, Png (Max 500x500 px)')}
                                </Typography>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        opacity: 0,
                                        cursor: 'pointer',
                                    }}
                                />
                            </>
                        )}
                    </Box>
                    {errors.deviceImage && (
                        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                            {errors.deviceImage}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}